import { useCallback, useState } from 'react';

interface useModalReturn {
  isOpen: boolean;
  setOpen(): void;
  setClose(): void;
  toggle(): void;
}

export default function useModal(initialModalState?: boolean): useModalReturn {
  const [modalOpen, setModalOpen] = useState<boolean>(!!initialModalState);

  const setOpen = useCallback(() => {
    setModalOpen(true);
  }, []);

  const setClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  const toggle = useCallback(() => {
    setModalOpen((prev) => !prev);
  }, []);

  return {
    isOpen: modalOpen,
    setOpen,
    setClose,
    toggle,
  };
}
